import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'


/**
 * 
 * @param {string} token 
 * @param {{
 *  name: string
 *  template_id: string
 *  paymentId: string
 *  lang: string
 *  provider: string
 *  isTemp?: boolean
 * }} data 
 * @returns {Promise<Response>}
 * @throws {Error | string}
 */
const PostVideoRegister = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/video/register`
        const body = { ...data };
        const config = { headers: { Authorization: `Bearer ${token}` } }

        const response = await axios.post(url, body, config)

        const result = response.status === 200;
        const resultData = response.data;
         
        if (result && typeof resultData === "object" && Object.keys(resultData).length !== 0) return new Response(result, resultData);
        else return new Response(false, PUBLIC_ERROR_CODE.ERR_INVALID_PARAM); //파라미터를 잘못 보낼경우 빈객체로 넘어와서 일단 ERR_INVALID_PARAM 에러코드 반환
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            default:
                throw e
        }
    }
}
/**
 * 
 * @param {string} token 
 * @param {{
*  id: string
* }} data 
* @returns {Promise<Response>}
* @throws {Error | string}
*/
const GetVideoPreview = async (token, data) => {
    try {
        const url = `${GetBaseUrl()}/api/video/preview/${data.id}`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config);

        const result = response.status === 200;
        const resultData = response.data;
        if (result) return new Response(result, resultData);
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            default:
                throw e
        }
    }
}
/**
 * 
 * @param {string} token 
 * @param {{
 * type: string
 * _id: string
 * name: string
 * lang: string
 * material: string
 * cutModified: string
 * }} data 
 * @returns {Promise<Response>}
 * @throws {Error | string}
*/
const PostVideoRendering = async (token, data) => {
    try {
        const { type, _id, name, material, cutModified } = data;
        const url = `${GetBaseUrl()}/api/video/rendering`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.post(url, { type, _id, name, material, cutModified }, config);

        const result = response.status === 200;
        const resultData = response.data;
        if (result) return new Response(result, resultData);
    } catch (e) {
        throw e;
    }
}


export default {
    PostVideoRegister,
    GetVideoPreview,
    PostVideoRendering
}